import React, { useState, useEffect } from 'react';

import { Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import FonctionService from 'Services/FonctionService';
import { Link } from 'react-router-dom';

const Apps = (props) => {
    const history = useHistory();
    const {
        match: { params },
    } = props;
    const [fonction, setFonction] = useState(null);

    useEffect(() => {
        if (params.fonctionId) {
            FonctionService.getFonctionById(params.fonctionId)
                .then((result) => {
                    if (result.status === 200) {
                        setFonction(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const onDelete = () => {
        FonctionService.deleteFonction(fonction)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/fonction/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/fonction/index' }}>
                    Fonctions
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Delete</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">Delete Fonction</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.fonctionId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6 d-flex flex-column align-items-center">
                    <img src="/images/alert.svg" alt="" style={{ width: '100pt' }} className="d-block" />
                    <h4 className="py-3">Irreversible Action</h4>
                    <button className="btn btn-danger" onClick={onDelete}>
                        Delete {fonction && fonction.name}
                    </button>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
